/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
// import { Button } from "reactstrap";
import { toast } from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UncontrolledTooltip, CardHeader, CardBody, Button, Card } from "reactstrap";
import DataTable from "react-data-table-component";
import { Plus } from "react-feather";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { handleErrors } from "../../../services/handleErrors";
import useFetcher from "../../../hooks/useFetcher";
import { getNotasDePedidoCategory } from "../../../services/notasDePedidoServices";
import { LabSelect } from "../../course/select";
import { CustomLabel } from "../../../ui/labels";
import { InputText, InputTextArea } from "../../../ui/inputs";
import { SpinnerButtonPrimary } from "../../../ui/buttons";
import { GridGroup } from "../styles";
import { postInterviews, patchInterviews, getInterviews } from "../../../services/candidatosNPServices";
import { BlurSpinner } from "../../BlurSpinner";
import { patchFile, uploadFiles } from "../../../services/fileServices";
import { DownloadFileButton } from "../../RelevosInfoGeneral/styles";
import { handleClickFile } from "../../RelevosInfoGeneral/utils";
import { getFileIconName } from "../../../pages/FileManager/fileItem";
import { formatearFecha } from "../utils";

const createOrUpdateInterviews = async (medicalStudie, estudioId) => {
  if (estudioId) {
    const res = await patchInterviews(medicalStudie, estudioId);
    return res;
  }
  const res = await postInterviews(medicalStudie);
  return res;
};

export const uploadOrPatchFileInterviews = async (id, files, fileId) => {
  if (fileId && fileId !== undefined) {
    await patchFile({ entity: "candidatoEntrevista", entityId: id, fileId, files });
  } else {
    await uploadFiles({ entity: "candidatoEntrevista", entityId: id, files });
  }
};

const Interviews = ({ info, notaDePedidoId }) => {
  const { id } = info.candidato;
  const [interviews, isLoadingInterviews, , , fetchInterviews] = useFetcher(getInterviews, [id, notaDePedidoId]);
  const [categories, isLoadingCategoies] = useFetcher(getNotasDePedidoCategory, undefined, "categoryNP");
  const categoriasCandidato = categories && categories.estadoCandidatoNP;
  const fechaActual = moment().format("YYYY-MM-DD");
  const [fechaValue, setFechaValue] = useState(fechaActual);
  const [observacionesValue, setObservacionesValue] = useState("");
  const [cargoValue, setCargoValue] = useState("");
  const [tipoValue, setTipoValue] = useState("");

  const [interviewId, setInterviewId] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const [isLoadingFiles, setIsLoadingFiles] = useState("");
  const [fileId, setFileId] = useState(null);
  const [files, setFiles] = useState(null);
  const [fileName, setFileName] = useState("Seleccione un archivo");
  const [savingInterview, setSavingInterview] = useState(false);

  const conditionalCellStyles = [
    {
      when: (row) => row.id === selectedRowId,
      style: {
        backgroundColor: "#f2eeee",
      },
    },
  ];

  useEffect(() => {
    if (files && files.length > 0) {
      setFileName(files[0].originalname);
      setFileId(files[0].id);
    }
  }, [info]);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;
    setFileName(selectedFiles[0].name);
    setFiles(selectedFiles);
  };

  const tipoOptions = categoriasCandidato
    ? categoriasCandidato.tipoEntrevista
        .map((e) => {
          return { label: e.text, value: e.text };
        })
        .sort((a, b) => (a > b ? 1 : -1))
    : [];

  function getFunctionToFilter(filter, selected) {
    if (filter === "tipo") {
      setTipoValue(selected);
    }
  }
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const handleDatesChange = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaValue(fechaFormateada);
  };

  const handleDownloadFile = async (row) => {
    setIsLoadingFiles(row.id);
    await handleClickFile(row.Files[0]);
    setIsLoadingFiles("");
  };

  const handleRowClick = (row) => {
    if (row.id === selectedRowId) {
      setShowForm(false);
      setSelectedRowId(null);
      setInterviewId(null);
      setFechaValue(fechaActual);
      setObservacionesValue("");
      setCargoValue("");
      setTipoValue("");

      setFileId(null);
      setFileName("Seleccione un archivo");
      setFiles(null);
    } else {
      setShowForm(true);
      if (row.Files && row.Files.length > 0) {
        setFiles(row.Files[0]);
        setFileName(row.Files[0].originalname);
        setFileId(row.Files[0].id);
      } else {
        setFileId(null);
        setFileName("Seleccione un archivo");
        setFiles(null);
      }
      setSelectedRowId(row.id);
      setInterviewId(row.id);
      setFechaValue(row.fechaEntrevista ? moment(row.fechaEntrevista).format("YYYY-MM-DD") : fechaActual);
      setObservacionesValue(row.observaciones || "");
      setCargoValue(row.cargo || "");

      setTipoValue(tipoOptions.find((e) => e.value === row.tipo));
    }
  };

  const handleGuardar = async () => {
    setSavingInterview(true);
    const interviewData = {
      notaDePedidoId,
      candidatoNPId: id,
      fechaEntrevista: fechaValue,
      observaciones: observacionesValue || null,
      cargo: cargoValue || null,
      tipo: (tipoValue && tipoValue.value) || null, // agregar enum
    };

    if (!interviewData.fechaEntrevista || !interviewData.cargo || !interviewData.tipo) {
      toast.error("Por favor, complete todos los campos");
      return;
    }

    try {
      const response = await createOrUpdateInterviews(interviewData, interviewId);
      const newInterview = response.result;
      if (files && files.length > 0) await uploadOrPatchFileInterviews(newInterview.id, files, fileId);
      toast.success(response.message);
      fetchInterviews();
      setShowForm(false);
    } catch (error) {
      handleErrors(error, toast.error);
    }

    setSavingInterview(false);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
        <Card className="mb-3" style={{ position: "relative", zIndex: "0" }}>
          <BlurSpinner loading={isLoadingInterviews}>
            <CardBody className="pb-3">
              <DataTable
                title={
                  <CardHeader className="pt-1 pb-1 px-0 d-flex align-items-center justify-content-end">
                    <UncontrolledTooltip placement="top" target="addStudy">
                      Agregar entrevista
                    </UncontrolledTooltip>
                    <Button
                      type="button"
                      color="link"
                      id="addStudy"
                      onClick={() => {
                        setShowForm(true);
                        setSelectedRowId(null);
                        setInterviewId(null);
                        setFechaValue(fechaActual);
                        setObservacionesValue("");
                        setCargoValue("");
                        setTipoValue(null);

                        setFileId(null);
                        setFileName("Seleccione un archivo");
                        setFiles(null);
                      }}
                    >
                      <Plus size="28" color="#f0292a" />
                    </Button>
                  </CardHeader>
                }
                noDataComponent={
                  <div className="p-3">
                    <b>No se encontraron entrevistas</b>
                  </div>
                }
                onRowClicked={(row) => handleRowClick(row)}
                data={interviews}
                columns={[
                  {
                    name: "Id",
                    selector: (row) => row.id,
                    center: true,
                    style: {
                      cursor: "pointer",
                    },
                    // width: "80px",
                    conditionalCellStyles,
                  },
                  {
                    name: "Fecha",
                    selector: (row) => (row.fechaEntrevista ? moment(row.fecha).format("DD/MM/YYYY") : "-"),
                    center: true,
                    style: {
                      cursor: "pointer",
                    },
                    // // width: "120px",
                    conditionalCellStyles,
                  },
                  {
                    name: "Tipo",
                    selector: (row) => row.tipo,
                    center: true,
                    style: {
                      cursor: "pointer",
                    },
                    // width: "150px",
                    conditionalCellStyles,
                  },

                  {
                    name: "Archivo",
                    selector: (row) =>
                      row && row.Files && row.Files.length > 0 ? (
                        <>
                          <UncontrolledTooltip target={`downloadFile${row.id}`}>Descargar archivo</UncontrolledTooltip>
                          <DownloadFileButton
                            id={`downloadFile${row.id}`}
                            aria-label="download file"
                            type="button"
                            style={{ border: "none", background: "none", cursor: "pointer" }}
                            onClick={() => handleDownloadFile(row)}
                          >
                            <BlurSpinner isLoading={isLoadingFiles === row.id}>
                              <FontAwesomeIcon color="#293134" size="lg" icon={getFileIconName(row.Files[0].mimetype)} />
                            </BlurSpinner>
                          </DownloadFileButton>
                        </>
                      ) : (
                        "-"
                      ),
                    // width: "80px",
                    center: true,
                    compact: true,
                    style: {
                      textAlign: "center",
                      cursor: "pointer",
                    },
                    conditionalCellStyles,
                  },
                ]}
              />
            </CardBody>
          </BlurSpinner>
        </Card>

        {showForm && (
          <>
            <div>
              <GridGroup className="mb-3">
                <div>
                  <StylesDatePicker className="mb-1">
                    <CustomLabel htmlFor="fechaAbierta" className=" pt-0 w-100">
                      Fecha
                      <DatePicker
                        className="date-input digits w-100"
                        dateFormat="AAAA-MM-dd"
                        onChange={handleDatesChange}
                        value={formatearFecha(fechaValue)}
                        selected={fechaValue ? new Date(fechaValue).setDate(new Date(fechaValue).getDate() + 1) : null}
                      />
                    </CustomLabel>
                  </StylesDatePicker>
                </div>

                <div>
                  <CustomLabel htmlFor="tipo" className=" pt-0 w-100">
                    Tipo
                    <LabSelect
                      id="tipo"
                      name="tipo"
                      className="w-100"
                      onChange={handleReactSelectChange}
                      value={tipoValue}
                      placeholder="Seleccionar..."
                      isClearable
                      isLoading={isLoadingCategoies}
                      isDisabled={isLoadingCategoies}
                      options={tipoOptions}
                    />
                  </CustomLabel>
                </div>

                <div>
                  <CustomLabel htmlFor="cargo" className=" pt-0 w-100">
                    Cargo
                    <InputText
                      className="w-100"
                      type="text"
                      name="cargo"
                      onChange={(e) => {
                        setCargoValue(e.target.value);
                      }}
                      value={cargoValue}
                    />
                  </CustomLabel>
                </div>
              </GridGroup>

              <div className="mb-3">
                <CustomLabel htmlFor="observaciones" className="pt-0 w-100">
                  observaciones
                  <InputTextArea
                    className="w-100 mb-0"
                    type="observacionesl"
                    name="observaciones"
                    onChange={(e) => setObservacionesValue(e.target.value)}
                    value={observacionesValue}
                  />
                </CustomLabel>
              </div>

              <div className="mb-3">
                <CustomLabel htmlFor="apellido" className="pt-0 w-100">
                  Cargar entrevista
                  <div className="d-flex align-items-center">
                    <div className="custom-file">
                      <input
                        className="custom-file-input"
                        type="file"
                        id="upfile"
                        onChange={handleFileChange}
                        accept=".pdf, .xls, .xlsx, .doc, .docx, .jpg, .jpeg, .png"
                        style={{ cursor: "pointer", border: "none" }}
                        // disabled={formik.isSubmitting}
                      />
                      <label className="custom-file-label" htmlFor="upfile">
                        {fileName}
                      </label>
                    </div>
                  </div>
                </CustomLabel>
              </div>
            </div>
            <div className="my-2 d-flex justify-content-end" style={{ paddingTop: "10px", borderTop: "1px solid #CCCCCC" }}>
              <Button color="btn-secondary mr-2" onClick={() => setShowForm(false)}>
                Cancelar
              </Button>
              <SpinnerButtonPrimary isLoading={savingInterview} type="button" fontSize="12px" onClick={() => handleGuardar()}>
                Guardar entrevista
              </SpinnerButtonPrimary>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Interviews;
